const affiliateConfig = {
  enableAffiliateProgram: false,
  hideAffiliateInFooter: false,
};
export { affiliateConfig };
